import React, { useEffect } from "react";
import { connect } from "react-redux";

import { selectUserInfo } from "../auth.ducks";
import history, { navigateToLogin } from "../../../history";
import { checkEmptyObject } from "../../../services";
import { UserI } from "../../../typings/interfaces";

export interface UserRequiredLoginProps {
  history?: History;
  location?: Location;
  match?: { path: string; url: string; isExact: boolean; params: {} };
  staticContext?: any;
  user?: UserI | null;
}

export default (Com: Function) => {
  const UserRequiredLoginComponent = (props: UserRequiredLoginProps) => {
    const { user } = props;

    useEffect(() => {
      const isUserEmpty = user && Object.keys(user).length === 0;
      if (user == JSON.stringify({}) || isUserEmpty) {
        navigateToLogin(window.location.href);
        history.replace("/");
      }
    }, [user]);

    return checkEmptyObject(user) ? <Com {...props} /> : null;
  };

  UserRequiredLoginComponent.defaultProps = {
    user: {}
  };

  return connect(
    state => ({
      user: selectUserInfo(state)
    }),
    {}
  )(UserRequiredLoginComponent);
};



// WEBPACK FOOTER //
// ./src/routes/Auth/HOCs/requireUserLogin.tsx